const startSlider = () => {
  document.querySelectorAll('.js-recommendation-swiper-original').forEach((elem) => {
    let mobileLayout = elem.dataset.mobileLayout || 1;

    new Swiper(elem, {
      slidesPerView: mobileLayout,
      slidesPerGroup: 1,
      spaceBetween: 8,
      speed: 1000,
      navigation: {
        nextEl: elem.querySelector('.product-recommendations__slider-nav .swiper-button-next'),
        prevEl: elem.querySelector('.product-recommendations__slider-nav .swiper-button-prev'),
      },
      breakpoints: {
        576: { slidesPerView: 2, slidesPerGroup: 2 },
        750: { slidesPerView: 3, slidesPerGroup: 3 },
        1200: { slidesPerView: 4, slidesPerGroup: 4 },
      },
    });
  });
};

// Run on page ready
document.addEventListener("DOMContentLoaded", startSlider);

// Run again when sections are loaded by Shopify
document.addEventListener("shopify:section:load", startSlider);
